import { is } from 'ramda';

const isString = is(String);
export default isString;
